/**
 * Physical Exams Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    physicalExams: [],
    physicalExam: {}
};

// Getters
const getters = {
    physicalExams: state => {
        return state.physicalExams
    },

    physicalExam: state => {
        return state.physicalExam
    }
};

// Actions
const actions = {
    getPhysicalExams(context, payload) {
        function successCallback(response) {
            context.commit('getPhysicalExamsHandler', { physicalExams: response.data.examensClinique });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Physical.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getPhysicalExam(context, payload) {
        function successCallback(response) {
            context.commit('getPhysicalExamHandler', { physicalExam: response.data.examenClinique });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Physical.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createPhysicalExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'physical-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Physical.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updatePhysicalExam(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'physical-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Physical.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deletePhysicalExam(context, payload) {
        function successCallback(response) {
            context.commit('deletePhysicalExamHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Exam.Physical.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getPhysicalExamsHandler(state, { physicalExams }) {
        // Update physicalExams state
        state.physicalExams = physicalExams;
    },

    getPhysicalExamHandler(state, { physicalExam }) {
        // Update physicalExam state
        state.physicalExam = physicalExam;
    },

    deletePhysicalExamHandler(state, { index, successMessage }) {
        let i = state.physicalExams.findIndex(physicalExam => physicalExam.slug === index);

        if (~i) {
            state.physicalExams.splice(i, 1);

            router.push({ name: 'physical-exams' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}